import { CreateAmbassadorRequest, RepresentationTypes } from '@amzn/red-velvet-api';
import { AmbassadorRegistrationFormValues } from '../components/ambassadors/ambassadorRegistrationForm';
import { TFunction } from 'i18next';

export const ambassadorFormValuesToRequest = (
  values: AmbassadorRegistrationFormValues,
  alias = '',
  t: TFunction<'translation', undefined>
): CreateAmbassadorRequest => {
  const representationTypes: RepresentationTypes[] = [];
  if (values.siteRepresentation) {
    representationTypes.push(RepresentationTypes.SITE);
  }
  if (values.teamRepresentation) {
    representationTypes.push(RepresentationTypes.TEAM);
  }
  if (values.employeeLedGroupRepresentation) {
    representationTypes.push(RepresentationTypes.ELG);
  }

  return {
    alias,
    preferredLanguage: values.language?.label ?? '',
    siteLead: values.siteLead,
    representationTypes: representationTypes,
    heardAbout:
      values.howDidYouHear?.label === t('ambassadorRegistration.otherPleaseSpecify')
        ? [values.howDidYouHearSpecification]
        : [values.howDidYouHear?.label || ''],
    teamLocation: values.teamLocation?.value ?? undefined,
    teamName: values.teamName ?? undefined,
    teamSize: values.teamSize ?? undefined,
    ergName: values.ergName ?? undefined,
    ergLocation: values.ergLocation?.value ?? undefined,
  };
};
